import 'react-datepicker/dist/react-datepicker.css';
import ReactDatePicker from 'react-datepicker';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
  background-color: #eee;
  padding: 0 1.875rem;
`;

export const DatePickerWrapper = styled.div`
  position: relative;
  width: 85%;
  margin: 0.6rem 0;
  display: ${({ clicked, delayShowUp }) => (clicked && delayShowUp ? 'flex' : 'none')};
  z-index: 10;

  @media (min-width: 36rem) {
    width: 31.25rem;
  }

  @media (min-width: 48rem) {
    width: 42.5rem;
  }

  @media (min-width: 62rem) {
    display: flex;
    width: 11.25rem;
    margin: 0 10px;
  }

  @media (min-width: 75rem) {
    width: 14.375rem;
  }

  .calendar {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    fill: #0e78e0;
  }

  &[dir='rtl'] {
    .calendar {
      left: 1rem;
    }
    .datepicker {
      font-family: GESSTwoDWTCLight, sans-serif;
      font-size: 10px;

      @media (max-width: 1199.98px) {
        padding: 13px 20px;
        font-size: 16px;
        letter-spacing: 0;
        text-transform: none;
      }
    }
  }

  &[dir='ltr'] {
    .calendar {
      right: 1rem;
    }
  }

  .react-datepicker__triangle {
    transform: rotate(180deg) !important;
    left: 1rem !important;
    bottom: -0.325rem !important;

    &:after {
      border-bottom-color: #fff !important;
      border-width: 6px !important;
    }

    &:before {
      border-width: 6px !important;
    }
  }
.react-datepicker-wrapper{
  width: 100%;
}
  .react-datepicker-popper {
    width: 12.1875rem !important;
    height: 100% !important;
    transform: translate(0px, -13.25rem) !important;
    border-radius: 2px;
  }

  .react-datepicker__year--container,
  .react-datepicker__month-container {
    width: 12.1875rem !important;
    height: 100% !important;
  }

  .react-datepicker__month-wrapper {
    width: 100%;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-evenly;
    padding-bottom: 5px;
  }

  .react-datepicker__year-wrapper {
    width: 100%;
    height: 100%;
    max-width: 12.1875rem !important;
  }

  .react-datepicker__month,
  .react-datepicker__year {
    margin: 0;
    margin-top: -10px;
  }

  .react-datepicker__navigation-icon:before {
    border-color: #000;
    border-style: solid;
    border-width: 1px 1px 0 0;
    content: '';
    display: block;
    height: 4px;
    position: absolute;
    top: 6px;
    width: 4px;
  }

  .react-datepicker__navigation-icon--next:after {
    border-color: #000;
    border-style: solid;
    border-width: 1px 1px 0 0;
    content: '';
    display: block;
    height: 4px;
    position: absolute;
    top: 6px;
    width: 4px;
    transform: rotate(45deg) translate(-3px, 3px);
  }

  .react-datepicker__navigation-icon--previous:after {
    border-color: #000;
    border-style: solid;
    border-width: 1px 1px 0 0;
    content: '';
    display: block;
    height: 4px;
    position: absolute;
    top: 6px;
    width: 4px;
    transform: rotate(225deg) translate(-4.5px, 4.5px);
  }

  .react-datepicker__header:hover {
    background-color: #fefefe !important;
  }

  .react-datepicker__header {
    font-family: 'DINRegular';
    font-size: 13px;
    background-color: #fff;
    border-bottom: none;
    padding: 0;
    cursor: pointer;
    width: 7.5rem;
    height: 1.5rem;
    margin: 0.325rem auto;
    border-radius: 2px;
    &[dir='rtl'] {
      font-family: GESSTwoDWTCLight, sans-serif;
    }
  }

  .react-datepicker__year-text,
  .react-datepicker__month-text {
    padding: 1.0625rem 0 !important;
    width: 2.5rem !important;
    font-family: 'DINRegular';
    font-size: 13px;
    font-weight: 400;
    margin: 0 !important;
    z-index: 1;
    position: relative;
    &[dir='rtl'] {
      font-family: GESSTwoDWTCLight, sans-serif;
    }
  }

  .react-datepicker__year-text--selected,
  .react-datepicker__year-text--keyboard-selected,
  .react-datepicker__month--selected,
  .react-datepicker__month-text--keyboard-selected {
    background: rgb(73, 156, 215);
    background: linear-gradient(180deg, rgba(73, 156, 215, 1) 0%, rgba(0, 69, 204, 1) 100%);
  }

  .react-datepicker__year-wrapper {
    display: flex;
    flex-wrap: wrap;
    max-width: 180px;
    flex-direction: row;
    align-content: center;
    justify-content: space-evenly;
    align-items: center;
  }
`;

export const DatePicker = styled(ReactDatePicker)`
  font-family: ${({ dir }) => (dir === 'rtl' ? 'GESSTwoDWTCLight,sans-serif' : 'DINRegular')};
  font-size: 0.65rem;
  text-transform: uppercase;
  letter-spacing: ${({ dir }) => (dir === 'rtl' ? '' : '0.1rem')};
  width: 100%;
  min-height: 3.125rem;
  padding: 0.8125rem 1.25rem;
  border: none;

  &:focus {
    outline: 3px solid #b5d4f5;
  }
`;
